import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { ResourceSkillRestService } from "@app/services/hal/resource-skill-rest.service";
import { ResourceSkill } from "@app/models/rest/resource-skill";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class ResourceSkillStore extends RealTimeDataStore<ResourceSkill> {
  constructor() {
    const resourceSkillRestService = inject(ResourceSkillRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(resourceSkillRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("ResourceSkill");
  }
}
